import React, { useState, useEffect } from "react";
import {
  Form,
  Button,
  Card,
  Typography,
  Grid,
  theme,
  Row,
  Col,
  Checkbox,
  Divider,
  notification,
  ConfigProvider,
} from "antd";
import { usePassPageSrv } from "./usePassPageSrv";
import QRCode from "qrcode.react";
import BrandColors from "@brand-colors";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';
import { handleErrorNavigation } from "pages/ErrorPage/ErrorHandler";
import { useSelector } from "react-redux";
import whitelabelConfig from "@whitelabel-config";
import { usePageTitle } from "helpers/usePageTitle";

const PassPage = () => {
  const passService = usePassPageSrv();
  const [passDetails, setPassDetails] = useState(null);
  const [qrShow, setQrShow] = useState(false);
  const [isHover, setIsHover] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const { useToken } = theme;
  const { useBreakpoint } = Grid;
  const { Text, Title } = Typography;
  const { token } = useToken();
  const screens = useBreakpoint();
  const { t } = useTranslation();
  usePageTitle("PASS_PAGE.PAGE_TITLE", `Pass - ${process.env.REACT_APP_PRODUCT}`);
  const navigate = useNavigate();

  const uiState = useSelector((state: any) => state.portal.uiState);
  const preferredLanguage = useSelector(
    (state: any) => state.portal.uiState.Language
  );
  console.log(preferredLanguage,"preferredLanguage")
  const [isRightAlign, setIsRightAlign] = useState(false);

  useEffect(() => {    
    try {
      if (whitelabelConfig.uiSettings.rightAlignedLanguage.includes(preferredLanguage) === true) {
        setIsRightAlign(true);
      } else {
        setIsRightAlign(false);
      }
    } catch (e) {
      console.log("Error", e)
      handleErrorNavigation(e, navigate, t);
    }
  }, [ whitelabelConfig, preferredLanguage]);

  useEffect(() => {
    generatePass();
  }, []);

  const generatePass = async () => {
    try {
      const result = await passService.httpgetPassList();
      setPassDetails(result?.data);
    } catch (error) {
      console.error("Error fetching pass list:", error);
    }
  };
  const currentDate = new Date();
  const formattedDate = currentDate.toLocaleDateString("en-US", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
  const handleMouseEnter = () => {
    setIsHover(true);
  };
  const handleMouseLeave = () => {
    setIsHover(false);
  };
  const handleCheckboxChange = (checkedValues) => {
    setIsChecked(checkedValues.length > 0);
  };
  const handleGeneratePass = async () => {
    if (!isChecked) {
      notification.error({
        message: t("PASS_PAGE.ERROR"),
        description: t("PASS_PAGE.SELECT_DIVISION"),
      });
    } else {
      const transformData = (data) => {
        return data
          .filter((item) => item.MemberGroupDivisionID !== null)
          .map((item) => ({
            MemberGroupDivisionID: item.MemberGroupDivisionID,
            MemberTimeDifference: moment().utcOffset()
          }));
      };

      const transformedPayload = {
        MemberGroupDivisions: transformData(passDetails.MemberGroupDivisions),
      };

      try {
        const result = await passService.httpgeneratePass(transformedPayload);
        console.log("result", result);
        if (result.HTTP_STATUS === 200) {
          if (
            result.data?.Response.ResponseMessage !==
            "Member should take up the survey before generating the pass"
          ) {
            setQrShow(true);
          } else {
            notification.error({
              message: "Error",
              description: result.data?.Response.ResponseMessage,
            });
          }
        }
      } catch (error) {
        console.error("Error fetching pass list:", error);
      }
    }
  };
  const styles = {
    container: {
      margin: "0 auto",
      maxWidth: "450px",
      textAlign: "center",
      backgroundColor: token.colorBgContainer,
      zIndex: 100,
    },
    currentdate: {
      fontWeight: 600,
      color: "#5e4ad2",
      fontSize: "18px",
    },
    currentdate_new: {
      fontWeight: 600,
      color: "#5e4ad2",
      fontSize: screens.md ? "18px" : "16px",
      margin: "0",
    },
    header: {
      maxWidth: "85%",
      padding: "20px 0",
      margin: " 0 auto",
      fontWeight: "600",
    },
    cardbody: {
      fontSize: "16px",
      fontWeight: 600,
      color: "#333333",
    },
    mainheader: {
      height: "80px",
      padding: "15px 0",
      backgroundColor: BrandColors.HEADER_BG,
    },
    subheader: {
      maxWidth: "100%",
      borderTop: "1px solid #cccccc",
    },
    text: {
      color: "#333",
      fontSize: "12px",
      lineHeight: "21px",
    },
    button: {
      backgroundColor: isHover ? token.colorBgContainer : BrandColors.BUTTON_BG,
      borderColor: isHover ? BrandColors.BUTTON_BG : token.colorBgContainer,
      color: isHover ? BrandColors.BUTTON_BG : token.colorBgContainer,
      height: "42px",
      borderRadius: "50px",
      textTransform: "uppercase",
      fontWeight: "500",
      boxShadow: "none",
      fontSize: screens.md ? "14px" : "12px",
    }
  };
  return (
    <div
      className="row page-wrapper justify-content-md-center"
      data-testid="pass-page"
    >
      <div className="col-md-12 col-sm-12">
        <Card className="home-widget-card hls-container" style={{ borderRadius: "0" }}>
          <div className="card-body">
            {!qrShow ? (
              <div>
                {passDetails && (
                  <Card
                    className="section-pass"
                    style={{ backgroundColor: "rgba(0,0,0,.03)", borderRadius: "0" }}
                  >
                    <div className="card-header">
                      <Row justify="space-between" align="middle">
                        <Col>
                          <h4
                            className="passdetails-date"
                            style={styles.currentdate_new}
                          >
                            {formattedDate}
                          </h4>
                        </Col>
                        <Col>
                          <Form.Item style={{ marginBottom: "0px" }}>
                            <Button
                              block={true}
                              type="primary"
                              style={styles.button}
                              data-testid="generate"
                              onMouseEnter={handleMouseEnter}
                              onMouseLeave={handleMouseLeave}
                              onClick={handleGeneratePass}
                              id="generate-pass-btn"
                            >
                              {t("PASS_PAGE.GENERATE_PASS")}
                            </Button>
                          </Form.Item>
                        </Col>
                      </Row>
                    </div>
                    <Divider />
                    <div className="card-body" style={styles.cardbody}>
                      <Row justify="space-between" align="middle">
                        <Col>
                          <label
                            htmlFor="inputPassword"
                            className="col-sm-2 col-form-label division-label"
                          >
                            {t("PASS_PAGE.DIVISIONS")}
                          </label>
                        </Col>
                        <Col>
                          <div className="form-check d-flex align-items-center">
                            <Checkbox.Group data-testid="division-checkbox" onChange={handleCheckboxChange}>
                              {" "}
                              {passDetails?.MemberGroupDivisions?.map(
                                (division) => (
                                  <div key={division.MemberGroupDivisionID} style={{ display: "flex" }}>
                                    <ConfigProvider
                                      theme={{
                                        token: {
                                          colorPrimary: "#5e4ad2",
                                          fontFamily: "Montserrat, sans-serif",
                                          borderRadius: "100",
                                        },
                                      }}
                                    >
                                      <Checkbox
                                        className="form-check-input ng-untouched ng-pristine ng-valid"
                                        value={division.MemberGroupDivisionName}
                                        data-testid="test-input-checkbox"
                                        id={division.MemberGroupDivisionID}
                                        onChange={handleCheckboxChange}
                                      />
                                    </ConfigProvider>
                                    <span style={{ marginLeft: "5px" }}>
                                      {division.MemberGroupDivisionName},{" "}
                                      {division.MemberGroupLocation}
                                    </span>
                                  </div>
                                )
                              )}
                            </Checkbox.Group>
                          </div>
                        </Col>
                      </Row>
                      <ul className="list-group activity-list">
                        {!passDetails && (
                          <li className="list-group-item d-flex justify-content-between align-items-center">
                            <span>{t("PASS_PAGE.NO_RECORDS")}</span>
                          </li>
                        )}
                      </ul>
                    </div>
                  </Card>
                )}
              </div>
            ) : (
              ""
            )}
            {qrShow && (
              <div className="card text-center mb-0">
                <div className="card-body">
                  <QRCode
                    value={passDetails.MemberPassID}
                    size={256}
                    level="M"
                    data-testid="qrcode"
                    renderAs="canvas"
                  />
                  <Title style={styles.currentdate} level={5}>
                    {formattedDate}
                  </Title>
                  <Text style={styles.cardbody}>
                    {t("PASS_PAGE.NAME")}: {passDetails?.PassDetails?.MemberName}
                  </Text>
                  <Text style={styles.cardbody}>
                    {t("PASS_PAGE.DIVISIONS")}:{" "}
                    {passDetails.MemberGroupDivisions.map((division) => (
                      <span key={division.MemberGroupDivisionID}>
                        {division.MemberGroupDivisionName},{" "}
                        {division.MemberGroupLocation}
                      </span>
                    ))}
                  </Text>
                </div>
              </div>
            )}
            {passDetails && (
              <Text className="activity-list" style={{ marginTop: "10px", display: "block",textAlign: isRightAlign ? "right": "left" }}>{t("PASS_PAGE.NO_RECORDS")}</Text>
            )}
          </div>
        </Card>
      </div>
    </div>
  );
};

export default PassPage;